/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsDeploymentCommerce } from './vcdsDeploymentCommerce';
import { VcdsDeploymentInventoryTree } from './vcdsDeploymentInventoryTree';


export interface BasicVcdsDeploymentAttributes { 
    commerce?: VcdsDeploymentCommerce;
    inventory?: VcdsDeploymentInventoryTree;
    personas?: Array<string>;
}

